/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Events_This_WeekInputs */

const en_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

const de_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Woche`)
};

const es_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta semana`)
};

const fr_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette semaine`)
};

const it_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa settimana`)
};

const pt_br2_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta semana`)
};

const pl_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tym tygodniu`)
};

const hu_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ezen a héten`)
};

const ro_admin_dashboard_events_this_week = /** @type {(inputs: Admin_Dashboard_Events_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saptamana aceasta`)
};

/**
* | output |
* | --- |
* | "This week" |
*
* @param {Admin_Dashboard_Events_This_WeekInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_events_this_week = /** @type {((inputs?: Admin_Dashboard_Events_This_WeekInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Events_This_WeekInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_events_this_week(inputs)
	if (locale === "de") return de_admin_dashboard_events_this_week(inputs)
	if (locale === "es") return es_admin_dashboard_events_this_week(inputs)
	if (locale === "fr") return fr_admin_dashboard_events_this_week(inputs)
	if (locale === "it") return it_admin_dashboard_events_this_week(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_events_this_week(inputs)
	if (locale === "pl") return pl_admin_dashboard_events_this_week(inputs)
	if (locale === "hu") return hu_admin_dashboard_events_this_week(inputs)
	return ro_admin_dashboard_events_this_week(inputs)
});
export { admin_dashboard_events_this_week as "admin.dashboard.events_this_week" }